import React,{useEffect,useState,useRef} from 'react';
import { Link } from 'react-router-dom'
import { Form, Container, Row, Col } from "react-bootstrap";
import { useParams , useSearchParams,useNavigate } from "react-router-dom";
import * as AuthVerify from '../../lib/common';
import Axios from '../../lib/axios/axiosInstance';
import {BASE_URL} from '../../lib/constant';
import { Flip, Slide, toast } from 'react-toastify';
import Modal from 'react-bootstrap/Modal';
import { Select, Input, Table, Space, Button } from "antd";
import {SearchOutlined} from "@ant-design/icons";
import CustomTable from './CustomTable';
// import 'antd/dist/antd.css';
import 'antd/dist/antd.min.css';

const CatalogDetails = () => {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [catalogDetails, setCatalogDetails] = useState(false);
    const [catalogItems, setCatalogItems] = useState(false);
    const [newCartItemsFromContract, setNewCartItemsFromContract] = useState(false);
    const [selectedCartItemsFromContract, setSelectedCartItemsFromContract] = useState([]);
    const [selectedMatnum, setSelectedMatnum] = useState(false);
    const [emShow, setEmShow] = useState(false);
    const [dmShow, setDmShow] = useState(false);

    const [editPermission, setEditPermission] = useState(false);

    
    const [cSearchBy, setcSearchBy] = useState('matname');
    const [cSearchByType, setcSearchByType] = useState('text');
    const [cSearchByFilter, setcSearchByFilter] = useState('contain');
    const [cSearchValue, setcSearchValue] = useState('');

    const [ctotal, setcTotal] = useState(0);
    const [cpage, setcPage] = useState(1);
    const [cpageSize, setcPageSize] = useState(10);
    const cfilter = useRef({});
    const corderBy = useRef('');

    const [total, setTotal] = useState(0);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const filter = useRef({});
    const lastUrl = useRef({});
    const orderBy = useRef('');

    const contractData = useRef(false);

    const seachByOption = [
      {label: 'Name', value:'matname', type:'text'},
      {label: 'Contract price', value:'contractprice', type:'number'},
      {label: 'Selling price', value:'sellingprice', type:'number'},
      {label: 'Start Date', value:'startdate', type:'date'},
      {label: 'End Date', value:'enddate', type:'date'},
    ];

    const nonStringColoums = [
      'sellingprice','contractprice'
    ];
    const dateColoums = [
      'startdate','enddate'
    ];
    const searchFilterOptions = [
      {label: 'Contain', value:'contain', for:'text'},
      {label: 'Equal', value:'equal',for:'number'},
      {label: 'Greater Than', value:'gte',for:'number'},
      {label: 'Less Than', value:'lte',for:'number'},
    ];
    const [searchFilter, setSearchFilter] = useState(searchFilterOptions.filter(x=>x.for ==='text'));
    const resetSearchFilter = (e)=>{
      if(['number','date'].includes(seachByOption.filter(x=>x.value==e)[0].type)){
        var options=searchFilterOptions.filter(x=>x.for ==='number');
        setSearchFilter(options);
        setcSearchByFilter(options[0].value);
      }else{
        var options=searchFilterOptions.filter(x=>x.for ==='text');
        setSearchFilter(options);
        setcSearchByFilter(options[0].value);
      }
    }
    const getCatalogDetails = async (queryString, reset=false) => {
      const catalognum=searchParams.get("catalognum");//'SGS2022';
      const arnum=AuthVerify.getUser().arnum;//'ARM-90195171';//
      let filterQuery=''
        // Object.keys(filter.current).forEach(key => {
        //     if(filter.current[key] && filter.current[key][0]!=''){
        //         if(nonStringColoums.includes(key)){
        //           filterQuery+=`&filter=${key},equal,${filter.current[key][0]}`
        //         }
        //         else if(dateColoums.includes(key)){
        //           filterQuery+=`&filter=${key},equal,'${filter.current[key][0]}'`
        //         }
        //         else{
        //           filterQuery+=`&filter=${key},contain,${filter.current[key][0]}`
        //         }
        //     }
        // });
        if(cSearchBy && cSearchByFilter && cSearchValue!='' && !reset){
          setCatalogItems([])
          if(seachByOption.filter(x=>x.value==cSearchBy)[0].type=='date'){
            filterQuery+=`&filter=${cSearchBy},${cSearchByFilter},'${cSearchValue}'`;
          }
          else{
            filterQuery+=`&filter=${cSearchBy},${cSearchByFilter},${cSearchValue}`;
          }
          
        }
        let url=`/corporate/catalog/${arnum}/${catalognum}?${queryString}${filterQuery}${orderBy.current??''}`;
        if(lastUrl.current!=url){
            lastUrl.current=url;
        }else{
            return;
        }
        // url=`/corporate/catalog/${AuthVerify.getUser().arnum}/${searchParams.get("catalognum")}`
        await Axios.get(url)
        .then(function (response) {
            if (response && response.data?.data) {
                setCatalogDetails(response.data.data.catalog);
                if(response.data.data.items.count>0){
                  setTotal(response.data.data.items.count)
                  setCatalogItems(response.data.data.items.items);
                }
            }
            else {
              toast.error(response.statusText??"Data fetching failed !", {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 3000,
                transition: Slide,
              });
            }
        })
        .catch(function (error) {
          navigate('/');
        });
    };
    
    useEffect(async () => {
        setEditPermission(AuthVerify.getPermissions("Catalog")?.edit);
        getCatalogDetails(`limit=${pageSize}&offset=${page}`);
    }, [searchParams])

    // Get New Catalog Items from Contract
    // /api/corporate/catalog/ARM-22000075/CT0000H76FBXCZF/newcontractitem
    const getNewCartItemsFromList = async (queryString, force=false) => {
        if(force)setcSearchByType('text');
        const arnum=AuthVerify.getUser().arnum;
        const catalognum=catalogDetails.catalognum;

        let filterQuery=''
        if(cfilter.current){
          Object.keys(cfilter.current).forEach(key => {
            if(cfilter.current[key] && cfilter.current[key][0]!=''){
              if(nonStringColoums.includes(key)){
                filterQuery+=`&filter=${key},equal,${cfilter.current[key][0]}`
              }
              else if(dateColoums.includes(key)){
                filterQuery+=`&filter=${key},equal,'${cfilter.current[key][0]}'`
              }
              else{
                filterQuery+=`&filter=${key},contain,${cfilter.current[key][0]}`
              }
            }
          });
        }
        else{
          var selectedSearchBy=cSearchBy==''?seachByOption.length>0?seachByOption[0].value:'' :cSearchBy;
          if(nonStringColoums.includes(selectedSearchBy) && !force){
            filterQuery+=`&filter=${selectedSearchBy},equal,${cSearchValue}`
          }
          else if(dateColoums.includes(selectedSearchBy) && !force){
            filterQuery+=`&filter=${selectedSearchBy},equal,'${cSearchValue}'`
          }
          else{
            if(!force)filterQuery+=`&filter=${selectedSearchBy},contain,${cSearchValue}`;
          }
        }
        let url=`/corporate/catalog/${arnum}/${catalognum}/${contractData.current?'newcontractitem':'new'}?${queryString}${filterQuery}${corderBy.current??''}`;
        if(lastUrl.current!=url){
            lastUrl.current=url;
        }else{
            return;
        }
        // url=`/corporate/catalog/${arnum}/${catalognum}/${contract?'newcontractitem':'new'}`;
        await Axios.get(url)
        .then(function (response) {
            if (response && response.data?.data) {
                setcTotal(response.data?.data?.items.count)
                if(response.data?.data?.items.count>0){
                    response.data?.data?.items.items.forEach(item=>{
                        item.key=item.matnum
                    })
                    setNewCartItemsFromContract(response.data?.data?.items.items);
                }
                else{
                  setNewCartItemsFromContract([]);
                }
                setEmShow(true);
            }
            else {
              toast.error(response.statusText??"Data fetching failed !", {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 3000,
                transition: Slide,
              });
            }
        })
        .catch(function (error) {
          navigate('/');
        });
    };

    // Add New Catalog Item
    // https://devb2b.bizpoint-intl.com:3082/api/corporate/catalog/:arnum/:catalog/newitem
    const addNewCartItemsFromList = async () => {
        const arnum=AuthVerify.getUser().arnum;
        const catalognum=catalogDetails.catalognum;
        var data={item: []}
        selectedCartItemsFromContract.forEach(item=>{
            data.item.push({matnum:item});
        })
        await Axios.post(`/corporate/catalog/${arnum}/${catalognum}/newitem`,data)
        .then(function (response) {
            if (response && response.data?.data?.items) {
                setCatalogDetails(response.data.data.catalog);
                if(response.data.data.items)setCatalogItems(response.data.data.items);
                setEmShow(false);
                toast.success('Item added successfully', {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 3000,
                    transition: Slide,
                });
            }
            else {
              toast.error(response.statusText??"Data fetching failed !", {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 3000,
                transition: Slide,
              });
            }
        })
        .catch(function (error) {
          navigate('/');
        });
    };

    // Delete Catalog Item
    // "DELETE https://devb2b.bizpoint-intl.com:3082/api/corporate/catalog/:arnum/:catalognum/:matnum
    const deleteCatalogItem = async () => {
        const arnum=AuthVerify.getUser().arnum;
        const catalognum=catalogDetails?.catalognum;
        await Axios.delete(`/corporate/catalog/${arnum}/${catalognum}/${selectedMatnum}`)
        .then(function (response) {
            if (response && response.data?.data) {
                setCatalogDetails(response.data.data.catalog);
                if(response.data.data.items.count>0)setCatalogItems(response.data.data.items);
                setEmShow(false);
                setDmShow(false);
                toast.success('Item added successfully', {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 3000,
                    transition: Slide,
                });
            }
            else {
              toast.error(response.statusText??"Action failed !", {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 3000,
                transition: Slide,
              });
            }
        })
        .catch(function (error) {
        navigate('/');
        });
    };

    //#region Custom Table For Modal
    const columns = [
        {
          title: 'Product',
          key: 'matname',
          render: (_, record) => (
            <>
                <a href="#"><img src={BASE_URL+record.imageurl} alt="Product" style={{maxWidth:"65px"}}/></a>
            </>
          )
        },
        {
            title: "Name",
            key: 'matname',
            dataIndex: 'matname',
            sorter: {
              compare: (a, b) => a.matname + b.matname
            }
        },
        {
          title: "Contract price",
          dataIndex: 'contractprice',
          key: 'contractprice',
          sorter: {
            compare: (a, b) => a.contractprice - b.contractprice
          }
        },
        {
            title: 'Selling Price',
            key: 'sellingprice',
            dataIndex: 'sellingprice',
            sorter: {
              compare: (a, b) => a.sellingprice - b.sellingprice
            }
        },
    ];

    const handleChange = (pagination, filters, sorter) => {
      let offset = (pagination.current * pagination.pageSize) - pagination.pageSize;
      const limit = pagination.pageSize;
      const params = {};
    
      if (sorter.hasOwnProperty("column")) {
      //   params.order = { field: sorter.columnKey, dir: sorter.order };
          if(sorter.order){
              let newOrder = `&sortby=${sorter.columnKey}&orderby=${sorter.order.replaceAll('end','')}`
              if(orderBy.current!=newOrder){
                  params.order=newOrder;
                  pagination.current=1;
              }
          }
          else params.order='';
      }
      setPageSize(limit);
      setPage(pagination.current);
      orderBy.current=params.order??'';
      filter.current=filters;
      getCatalogDetails(`limit=${limit}&offset=${offset}`);
      // console.log(params,filters,sorter);
      // console.log(params);
  };
  const chandleChange = (pagination, filters, sorter) => {
    let offset = (pagination.current * pagination.pageSize) - pagination.pageSize;
    const limit = pagination.pageSize;
    const params = {};
  
    if (sorter.hasOwnProperty("column")) {
    //   params.order = { field: sorter.columnKey, dir: sorter.order };
        if(sorter.order){
            let newOrder = `&sortby=${sorter.columnKey}&orderby=${sorter.order.replaceAll('end','')}`
            if(corderBy.current!=newOrder){
                params.order=newOrder;
                pagination.current=1;
            }
        }
        else params.order='';
    }
    setcPageSize(limit);
    setcPage(pagination.current);
    corderBy.current=params.order??'';
    cfilter.current=filters;
    getNewCartItemsFromList(`limit=${limit}&offset=${offset}`);
};

    const onSelectChange = (newSelectedRowKeys) => {
        setSelectedCartItemsFromContract(newSelectedRowKeys);
    };

    const rowSelection = {
        selectedCartItemsFromContract,
        onChange: onSelectChange,
        selections: [
          Table.SELECTION_ALL,
          Table.SELECTION_INVERT,
          Table.SELECTION_NONE
        ],
    };
    //#endregion

    // #region Custom Table

    const columns_ = [
        {
          title: 'Product',
          dataIndex: 'imageurl',
          key: 'imageurl',
          render: (text) => <a href="#">
          <img src={BASE_URL+text} alt="Product" /></a>,
        },
        {
          title: 'Description',
          key: 'matname',
          dataIndex: 'matname',
          sorter: {
            compare: (a, b) => a.matname + b.matname
          },
          // filterDropdown:({setSelectedKeys,selectedKeys,confirm,clearFilters})=>{
          //   return (
          //   <>
          //   <Input 
          //       autoFocus 
          //       style={{maxWidth:'55%',margin:"5px"}}
          //       value={selectedKeys[0]}
          //       onChange={(e)=>{
          //           setSelectedKeys(e.target.value?[e.target.value]:[]);
          //       }}
          //       onPressEnter={()=>{
          //           confirm()
          //       }}
          //       onBlur={()=>{
          //           confirm()
          //       }}
          //       placeholder='Seach by name'
          //   ></Input>
          //   <Button type='primary' onClick={()=>{confirm()}}>Search</Button>
          //   <Button type='danger' onClick={()=>{filter.current.matname='';clearFilters();confirm();getCatalogDetails(`limit=${pageSize}&offset=0`)}}>Reset</Button>
          //   </>)
          // },
          // onFilter:(value,record)=>{
          //   return record;
          // },
          // filterIcon:()=>{
          //   return <SearchOutlined/>
          // },
          render: (_, record) => (
            <>
            <p className="product-name">
                <Link to={"/product-detail?matnum="+record.matnum}>{record.matname}</Link>
            </p>
            <small className="cart_ref">Matnum: {record.matnum}</small><br />
          </>
          )
        },
        {
            title: 'Selling Price',
            key: 'sellingprice',
            dataIndex: 'sellingprice',
            sorter: {
              compare: (a, b) => a.sellingprice - b.sellingprice
            }
        },
        {
          title: 'Contract price',
          dataIndex: 'contractprice',
          key: 'contractprice',
          sorter: {
            compare: (a, b) => a.contractprice - b.contractprice
          }
        },
        {
          title: 'Contract No',
          dataIndex: 'contractno',
          key: 'contractno',
          sorter: {
            compare: (a, b) => a.contractno + b.contractno
          }
        },
        {
          title: 'Start Date',
          dataIndex: 'startdate',
          key: 'startdate',
          sorter: {
            compare: (a, b) => a.startdate - b.startdate
          }
        },
        {
          title: 'End Date',
          dataIndex: 'enddate',
          key: 'enddate',
          sorter: {
            compare: (a, b) => a.enddate - b.enddate
          }
        },
        {
          title: 'Action',
          key: 'action',
          render: (_, record) => (
            <>
              <a>Print</a>|
              <a>Export</a>|
              {editPermission && <a onClick={()=>{setSelectedMatnum(record.matnum); setDmShow(true);}} style={{color:"red"}}>Delete</a>}
            </>
          ),
        },
    ];
    // #endregion
    
    return (
        <section className="main-container col1-layout">
            <div className="main">
                <div className="col-main">
                    <div className="shopping-cart-inner">
                        <div className="page-content">
                            <div className="page-content checkout-page">
                                
                                    <div className="box-border" style={{margin:"auto", maxWidth:"80%"}}>
                                    
                                    
                                      <CustomTable/>
                                        <div className="cart_navigation">
                                            <button className="button btn-proceed-checkout" title="Proceed to Checkout" type="button" onClick={()=>navigate('/my-account?activeKey=Catalog')}><span>Back to Catalog Listing</span></button>
                                        </div>
                                    </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >

            <Modal show={emShow} dialogClassName="modal-90w" animation={false} fade={false} style={{opacity:1}} onHide={()=>setEmShow(false)}>
                <Modal.Header closeButton={false}>
                    <Modal.Title>Create New Catalog</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col>
                    <Col md={2}>
                        Search By
                    </Col>
                    
                    <Col md={3}>
                      <Select 
                        defaultValue={seachByOption.length>0?seachByOption[0].value:''}
                        onChange={(e)=>{setcSearchBy(e);setcSearchByType(seachByOption.filter(x=>x.value==e)[0].type);}}
                        style={{width:"100%"}}
                        options={seachByOption}
                      >
                      </Select>
                    </Col>

                    <Col md={4}>
                        <Input 
                          type={cSearchByType}
                          style={{margin:"0",width:"100%"}}
                          value={cSearchValue}
                          onChange={(e)=>{setcSearchValue(e.target.value)}}
                          placeholder="Enter search keyword"
                        ></Input>
                    </Col>

                    <Col md={3}>
                      <Button type='primary' style={{float:"right"}} onClick={()=>{cfilter.current=false; getNewCartItemsFromList(`limit=${pageSize}&offset=0`)}}><SearchOutlined/> Search</Button>
                    </Col>
                    </Col>
                  </Row>
                    {/* <Table className="osya table table-bordered jtv-cart-summary" style={{marginTop:"20px"}} rowSelection={rowSelection} columns={columns} dataSource={newCartItemsFromContract}/> */}
                    <Table 
                      className="osya table table-bordered jtv-cart-summary" 
                      style={{marginTop:"20px",overflowY:"auto"}} 
                      columns={columns} 
                      rowSelection={rowSelection}
                      dataSource={newCartItemsFromContract}
                      onChange={chandleChange}
                      pagination={{
                          current:cpage,
                          pageSize:cpageSize,
                          total:ctotal
                      }}
                    />
                    <button className="button" title="Proceed to Checkout" type="button" onClick={()=>addNewCartItemsFromList()}><span>Add to my catalog</span></button>
                </Modal.Body>
            </Modal>

            <Modal show={dmShow} dialogClassName="modal-90w" animation={false} fade={false} style={{opacity:1}} onHide={()=>setDmShow(false)}>
        <Modal.Header closeButton={false}>
          <Modal.Title>Delete Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure about the delete ?
        </Modal.Body>
        <Modal.Footer>
        <button
              className="button btn-primary"
              title="Proceed to Checkout"
              type="button"
              onClick={()=>deleteCatalogItem()}
              style={{
                marginRight: "10px",
                padding: "10px"
              }}
              >
            <span>Confirm</span>
          </button>
          <button
            className="button btn-danger"
            title="Proceed to Checkout"
            type="button"
            onClick={()=>setDmShow(false)}
            style={{
              marginRight: "10px",
              padding: "10px"
            }}
          >
            <span>Close</span>
          </button>
        </Modal.Footer>
      </Modal>
        </section >

    )
}

export default CatalogDetails